// Central registry of test IDs for Lavish Luxe Detailing
export const LUXE = {
  // Navigation
  navHome: 'nav-home',
  navServices: 'nav-services',
  navAbout: 'nav-about',
  navGallery: 'nav-gallery',
  navBooking: 'nav-booking',
  navContact: 'nav-contact',
  navLogo: 'nav-logo',
  navBookCta: 'nav-book-cta',
  navMobileToggle: 'nav-mobile-toggle',

  // Hero
  heroBookBtn: 'hero-book-btn',
  heroPackagesBtn: 'hero-packages-btn',
  heroHeadline: 'hero-headline',

  // Services strip
  serviceInterior: 'service-card-interior',
  serviceExterior: 'service-card-exterior',
  servicePremium: 'service-card-premium',

  // Packages
  packageEssential: 'package-essential-shine',
  packageInterior: 'package-interior-refresh',
  packageExterior: 'package-exterior-shine',
  packageComplete: 'package-complete-detail',
  packagePremium: 'package-premium-detail',
  packageBookBtn: 'package-book-btn',

  // Add-ons
  addonEngine: 'addon-engine-bay',
  addonHeadlight: 'addon-headlight',
  addonPetHair: 'addon-pet-hair',
  addonOdor: 'addon-odor',
  addonCeramic: 'addon-ceramic',
  addonDoorJamb: 'addon-door-jamb',

  // Gallery
  galleryItem: 'gallery-item',
  galleryLightbox: 'gallery-lightbox',
  galleryLightboxClose: 'gallery-lightbox-close',

  // Booking
  bookingForm: 'booking-form',
  bookingName: 'booking-name',
  bookingPhone: 'booking-phone',
  bookingEmail: 'booking-email',
  bookingVehicleType: 'booking-vehicle-type',
  bookingService: 'booking-service',
  bookingDate: 'booking-date',
  bookingTime: 'booking-time',
  bookingLocation: 'booking-location',
  bookingNotes: 'booking-notes',
  bookingSubmit: 'booking-submit',
  bookingSuccess: 'booking-success',

  // Contact
  contactForm: 'contact-form',
  contactName: 'contact-name',
  contactEmail: 'contact-email',
  contactMessage: 'contact-message',
  contactSubmit: 'contact-submit',
  contactSuccess: 'contact-success',
  contactPhoneLink: 'contact-phone-link',
  contactEmailLink: 'contact-email-link',

  // Payment step
  paymentDepositCard: 'payment-deposit-card',
  paymentDepositAmount: 'payment-deposit-amount',
  paymentPayApplePay: 'payment-pay-applepay-btn',
  paymentPayZelle: 'payment-pay-zelle-btn',
  paymentSkipBtn: 'payment-skip-btn',
  paymentZelleCard: 'payment-zelle-card',
  paymentZelleHandle: 'payment-zelle-handle',
  paymentDone: 'payment-done',
  paymentStatusPending: 'payment-status-pending',
  paymentStatusPaid: 'payment-status-paid',
  paymentStatusFailed: 'payment-status-failed',

  // Footer
  footerBookCta: 'footer-book-cta',
  footerCall: 'footer-call',

  // Testimonials
  testimonialCard: 'testimonial-card',

  // Admin
  adminLoginForm: 'admin-login-form',
  adminLoginInput: 'admin-login-input',
  adminLoginSubmit: 'admin-login-submit',
  adminDashboard: 'admin-dashboard',
  adminTabBookings: 'admin-tab-bookings',
  adminTabMessages: 'admin-tab-messages',
  adminBookingRow: 'admin-booking-row',
  adminMessageRow: 'admin-message-row',
  adminConfirmBtn: 'admin-confirm-btn',
  adminDeclineBtn: 'admin-decline-btn',
  adminMarkPaidBtn: 'admin-mark-paid-btn',
  adminLogout: 'admin-logout',
};
